// Builds an absolute URL to the native CreativeWizard (EditAdCreative) surface
// for a creative. The app router mounts under the `/builder` basename
// (see components/router/router.tsx) with the route
// `/:businessID/creatives/:creativeID`. Centralized here so a future basename
// change is a single edit, and so packet hosts can route `creative` comment
// deep-links to CreativeWizard instead of the packet URL.
export const creativeWizardUrl = (businessID: number, creativeID: string | number): string =>
  `${window.location.origin}/builder/${businessID}/creatives/${creativeID}`

// The same URL with a comment deep-link attached, matching the params
// `readCommentDeepLink` and CommentThread's `?commentId=` effect both read — so
// the Wizard opens on the creative AND scrolls its comment drawer to the thread.
// Used where a creative comment is opened from another surface's comment list;
// `pageUrlBaseForAnchor` deliberately does NOT use this, since CommentThread
// overwrites the search component with its own params.
export const creativeWizardCommentUrl = (
  businessID: number,
  creativeID: string | number,
  commentId: number
): string => {
  const url = new URL(creativeWizardUrl(businessID, creativeID))
  url.search = new URLSearchParams({
    commentId: String(commentId),
    anchorType: 'creative',
    anchorId: String(creativeID),
  }).toString()
  return url.toString()
}
